import apiClient from 'utilities/apiClient';

export const wastage = (url, payload) => {
  return apiClient.get(`${apiClient.Urls.wastage}/${url}`, payload, true);
};

export const updatewastage = (url, payload) => {
  return apiClient.post(`${apiClient.Urls.wastage}/${url}`, payload, true);
};
